export default __webpack_public_path__ + "static/media/bjorn.22b70341.png";